module.exports = __webpack_public_path__ + "static/brand-qiangli-03dd08bcf5123fea68ff37194f705634.png";